import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/BrandLeaderBoardSagas";
import DatePicker from "./smartComponents/datePicker";
import FilterByView from "./smartComponents/filterByView";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import MetricsCards from "./smartComponents/metricsCards";
import { DataPoints } from "./smartComponents/dataPoint";
import MetricsFilter from "./smartComponents/metricsFilter";
import RankTable from "./smartComponents/rankTable";
import BrandLeaderBoardLearnMore from "./smartComponents/brandLeaderBoardLearnMore";
import UpdateBtns from "./smartComponents/UpdateBtns";
import "./brandLeaderBoard.css.scss";

const BrandLeaderBoardModule = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.brandLeaderboard.isLoading);
  const cardsData = useSelector((state) => state.brandLeaderboard.cardsData);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const getContent = () => (
    <>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="filters-wrapper">
          <FilterByView />
          <div className="date-select-box monthly">
            <p>Metrics</p>
            <MetricsFilter />
          </div>

          <div className="date-select-box monthly">
            <p>Date</p>
            <DatePicker />
          </div>
          <UpdateBtns />
        </div>
      </div>
      {!isLoading ? (
        cardsData?.all_data?.length ? (
          <>
            <div className="rank-data-container">
              <DataPoints />
              <RankTable />
            </div>
            <MetricsCards />
          </>
        ) : (
          <p className="error">No data available</p>
        )
      ) : (
        <LoadingAnimation text="Loading data" />
      )}
    </>
  );

  return (
    <div id="brandLeaderBoardModule-root">
      <SectionToggle
        title="Brand Leaderboard"
        content={getContent()}
        learnMore={<BrandLeaderBoardLearnMore />}
      />
    </div>
  );
};
export default BrandLeaderBoardModule;
